<template>
	<div>
		<v-dialog v-model="dialog" persistent width="500px">
			<v-card>
				<v-toolbar dark color="primary" dense>
					<v-toolbar-title style="color: white">チームを編集する</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="close"><v-icon>mdi-close</v-icon></v-btn>
				</v-toolbar>
				<v-card-text class="mt-2">
					<v-form>
						<v-text-field v-model="name" label="チーム名" required></v-text-field>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="save"> 保存 </v-btn>
				</v-card-actions>
				<v-divider></v-divider>
				<v-card-text class="mt-2">
					<p>チームリーダー設定</p>
					<p>
						現在のチームリーダー:
						{{ team.team_leader ? fullName(team.team_leader.user) : "設定なし" }}
					</p>
					<v-form>
						<v-select
							v-model="teamLeaderId"
							:items="team.users"
							:item-text="getUserName"
							item-value="id"
							label="チームリーダー"
							:rules="[(v) => !!v || 'チームリーダーを選択してください']"
						/>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="saveLeader"> 保存 </v-btn>
				</v-card-actions>

				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red darken-1" text @click="deleteTeam"> チームの削除 </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
export default {
	name: "EditTeamNameDialog",
	data() {
		return {
			dialog: false,
			name: "",
			team: { users: [] },
			teamLeaderId: "",
		}
	},
	methods: {
		getUserName(item) {
			return item.last_name + " " + item.first_name
		},
		open(team) {
			this.dialog = true
			this.team = team
			this.name = team.name
		},
		close() {
			this.dialog = false
			this.team = { users: [] }
			this.name = ""
		},
		saveLeader() {
			if (!this.teamLeaderId) {
				return
			}
			const headers = authenticate.setHeader()
			axios
				.post(
					`/erp/v1/teams/leaders`,
					{ user_id: this.teamLeaderId, team_id: this.team.id },
					{ headers }
				)
				.then((response) => {
					this.close()
					this.$store.dispatch("setFlash", {
						text: response.data.message,
						type: "notice",
					})
					this.$emit("teamNameUpdated")
				})
				.catch((error) => {
					console.log(error)
				})
		},
		save() {
			if (!this.name) {
				return
			}
			const headers = authenticate.setHeader()
			axios
				.put(`/erp/v1/teams/${this.team.id}`, { name: this.name }, { headers })
				.then((response) => {
					this.close()
					this.$store.dispatch("setFlash", {
						text: response.data.message,
						type: "notice",
					})
					this.$emit("teamNameUpdated")
				})
				.catch((error) => {
					console.log(error)
				})
		},
		fullName(user) {
			if (user == undefined) {
				return "設定されていません"
			} else {
				return user.last_name + user.first_name
			}
		},
		deleteTeam() {
			// If the team has members, it cannot be deleted.
			let team = this.team
			if (team.users.length > 0) {
				this.$store.dispatch("setFlash", {
					text: "チームにメンバーがいるため、削除できません。",
					type: "error",
				})
				return
			}
			const headers = authenticate.setHeader()
			axios
				.delete("/erp/v1/teams/" + this.$route.params.id + "?team_id=" + team.id, {
					headers,
				})
				.then((response) => {
					this.$store.dispatch("setFlash", {
						text: response.data.message,
						type: "notice",
					})
					this.close()
					this.$emit("teamNameUpdated")
				})
				.catch((error) => {
					console.log(error)
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>

<style scoped></style>
